import { RootState } from "../store";

export const selectTournamentsLoading = (state: RootState) =>
  state.tournaments.tournamentsLoading;
export const selectAvailableTournaments = (state: RootState) =>
  state.tournaments.availableTournaments;
export const selectMyApplicationsTournaments = (state: RootState) =>
  state.tournaments.myApplicationsTournaments;
export const selectMyCreatedTournaments = (state: RootState) =>
  state.tournaments.myCreatedTournaments;
export const selectUserTournamentStatus = (state: RootState) =>
  state.tournaments.userTournamentStatus;
export const selectTournamentApplicationsCount = (state: RootState) =>
  state.tournaments.applicationsCount;
export const selectTournamentTypes = (state: RootState) =>
  state.tournaments.tournamentTypes;
